// extracted by mini-css-extract-plugin
export default {"selectedTab":"GoalTargetGroup_selectedTab__61Jcf","treeView":"GoalTargetGroup_treeView__jxkdo","isLoading":"GoalTargetGroup_isLoading__L5PlD"};